import { Component, OnInit } from '@angular/core';
import { DataService } from '../../../data.service';

@Component({
  selector: 'lc-order-succesguide',
  templateUrl: './order-succesguide.component.html',
  styleUrls: ['./order-succesguide.component.scss']
})
export class OrderSuccesguideComponent implements OnInit {

  did_order_guide: boolean;
  order_did_fail: boolean;
  constructor(private dataService: DataService) { }

  ngOnInit() {
  }

  orderSuccesGuide() {
    this.dataService.subscribe_to_list('/t/j/s/fuhydk/').subscribe(res =>{
      if( res.Status == 200)
        this.did_order_guide = true;
      else {
        this.did_order_guide = false;
        this.order_did_fail = true;
      }
    }, error =>{
      this.did_order_guide = false;
      this.order_did_fail = true;
    });

  }

}



// WEBPACK FOOTER //
// /Users/matthijs/projects/PHILIPS/philips-dental-pro/shop/src/app/components/zoom/order-succesguide/order-succesguide.component.ts